import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newCustomrelease() {
    let customDetails = {
      fileopening_id: $(".fileopening_id").val(),
      lodged_date: $(".lodged_date").val(),
      passed_date: $(".passed_date").val(),
      t810_entry: $(".t810_entry").val(),
      total_bond_amount:  $(".total_bond_amount").val(),
      c400: $(".c400").val(),
      im4: $(".im4").val(),
      declaration_t1: $(".declaration_t1").val(),
      declaration_wt8: $(".declaration_wt8").val(),
      t1_date: $(".t1_date").val(),
      t1_expiry_date: $(".t1_expiry_date").val(),
      wt8_expirydays: $(".wt8_expirydays").val(),
      cfs: $(".cfs").val(),
      t810_expiry: $(".t810_expiry").val(),
      remarks: $(".remarks").val()
    };
    $(".creatingCustomrelease").hide();
    $(".creatingCustomreleaseLoader").show();
    baseurl.post(rt.newCustomrelease, customDetails).then(res => {
      $(".creatingCustomrelease").show();
      $(".creatingCustomreleaseLoader").hide();

      //checking for response codes from  backend api

      if (res.data.code === 200) {
        //success code
        suc.customreleaseCreateSuccess();
        router.push("/managecustomreleases");
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //custom release data exits
        ers.CustomreleaseExists();
      } else if (res.data.code === 404) {
        //error on creating custom release data
        ers.errorCreatingCustomrelease();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //sesson exipired
        ses.sessionComplete();
      }
    });
  },

  loadCustomreleases({ commit }) {
    baseurl.get(rt.loadCustomreleases).then(res => {
      $(".customreleasesLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code and mutations
        commit("STORE_CUSTOMRELEASES", res.data.customreleases);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingCustomrelease();
      } else if (res.data.code === 405) {
        //no permissions to read
        commit("STORE_CUSTOMRELEASES", []);
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  customreleaseUpdate({ commit }) {
    let customDetails = {
      id: $(".id").val(),
      fileopening_id: $(".fileopening_id").val(),
      lodged_date: $(".lodged_date").val(),
      passed_date: $(".passed_date").val(),
      t810_entry: $(".t810_entry").val(),
      total_bond_amount:  $(".total_bond_amount").val(),
      c400: $(".c400").val(),
      im4: $(".im4").val(),
      declaration_t1: $(".declaration_t1").val(),
      declaration_wt8: $(".declaration_wt8").val(),
      t1_date: $(".t1_date").val(),
      t1_expiry_date: $(".t1_expiry_date").val(),
      wt8_expirydays: $(".wt8_expirydays").val(),
      cfs: $(".cfs").val(),
      t810_expiry: $(".t810_expiry").val(),
      remarks: $(".remarks").val()
    };

    $(".updatingCustomrelease").hide();
    $(".updatingCustomreleaseLoader").show();
    baseurl.post(rt.updateCustomrelease, customDetails).then(res => {
      $(".updatingCustomrelease").show();
      $(".updatingCustomreleaseLoader").hide();

      //checking response codes from backend api

      if (res.data.code === 200) {
        //success code
        suc.customreleaseUpdateSuccess();
        commit("STORE_CUSTOMRELEASES", res.data.customreleases);
        setTimeout(() => {
          router.push("/managecustomreleases");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating data
        ers.errorUpdatingCustomrelease();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  viewCustomrelease({ commit }, customreleaseId) {
    commit("STORE_CUSTOMRELEASE_UPDATE", customreleaseId);
    router.push("/updatecustomrelease");
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/customreleases/actions.js